"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrathAbilityHandler = exports.WrathActorAbilityFactory = exports.WrathAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class WrathAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Wrath;
        this.__typeName = "Wrath";
    }
}
exports.WrathAbilityArgs = WrathAbilityArgs;
let WrathActorAbilityFactory = class WrathActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Wrath", "Self", 4);
    }
};
WrathActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Wrath")
], WrathActorAbilityFactory);
exports.WrathActorAbilityFactory = WrathActorAbilityFactory;
let WrathAbilityHandler = class WrathAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Focus, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Focus")),
                        new core_1.LinkedEventHandlerEffectArgs("Effect On Hit", "Applies slow on hit", false, container.registerEventHandlerScript(ability.invokerId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, "ApplyEffect_OnAttack", {
                            applyTo: "attacked",
                            onHitOnly: true,
                            effects: [{
                                    duration: Duration_1.Duration.Turns(2),
                                    effect: new core_1.WeaknessEffectArgs(),
                                    percentChance: 100
                                }]
                        }))
                    ], false),
                });
            }
        });
    }
};
WrathAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Wrath)
], WrathAbilityHandler);
exports.WrathAbilityHandler = WrathAbilityHandler;
